import React from "react";

const CartCashierIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.727273"
        y="0.727273"
        width="24.5455"
        height="24.5455"
        rx="12.2727"
        fill="white"
      />
      <rect
        x="0.727273"
        y="0.727273"
        width="24.5455"
        height="24.5455"
        rx="12.2727"
        stroke="#916CF1"
        strokeWidth="0.545455"
      />
      <path
        d="M11.5931 18.7272C12.0187 18.7272 12.3636 18.3823 12.3636 17.9568C12.3636 17.5312 12.0187 17.1863 11.5931 17.1863C11.1676 17.1863 10.8227 17.5312 10.8227 17.9568C10.8227 18.3823 11.1676 18.7272 11.5931 18.7272Z"
        fill="#19AE57"
        stroke="#15112D"
        strokeWidth="0.122257"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.642 18.7272C17.0675 18.7272 17.4125 18.3823 17.4125 17.9568C17.4125 17.5312 17.0675 17.1863 16.642 17.1863C16.2165 17.1863 15.8715 17.5312 15.8715 17.9568C15.8715 18.3823 16.2165 18.7272 16.642 18.7272Z"
        fill="#FD561F"
        stroke="#15112D"
        strokeWidth="0.122257"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1175 18.7272C14.5431 18.7272 14.888 18.3823 14.888 17.9568C14.888 17.5312 14.5431 17.1863 14.1175 17.1863C13.692 17.1863 13.3471 17.5312 13.3471 17.9568C13.3471 18.3823 13.692 18.7272 14.1175 18.7272Z"
        fill="#F7AD3C"
        stroke="#15112D"
        strokeWidth="0.122257"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.63635 7.27271H8.86363C8.86363 7.27271 9.12641 8.43625 9.29478 9.1818C9.63122 10.6715 10.0933 12.7176 10.3644 13.9179C10.4955 14.4982 11.0107 14.9091 11.6056 14.9091H17.07C17.6665 14.9091 18.183 14.4947 18.3124 13.9125L19.3636 9.1818"
        stroke="#0B0C0E"
        strokeWidth="0.545455"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3636 9.18188H9.5"
        stroke="#0B0C0E"
        strokeWidth="0.545455"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CartCashierIcon;
